import React, { useState } from 'react'
import PropTypes from 'prop-types'
import PDFWindow from '../Windows/PDFWindow/PDFWindow'
import MacStyleWindow from '../Windows/MacStyleWindow/MacStyleWindow'
import FolderIcon from '../FolderIcon/FolderIcon'

import folderIcon from '../../assets/icons/Apps/folder-icon.png'
import appStoreIcon from '../../assets/icons/Apps/appstore-icon.png'

import './DesktopContent.css'

function DesktopContent() {
  const [openWindow, setOpenWindow] = useState(null)
  const [currentPdf, setCurrentPdf] = useState(null)
  const [defaultMenu, setDefaultMenu] = useState('appStore') // 默认菜单项

  // 关闭窗口
  const closeWindow = () => {
    setOpenWindow(null)
    setCurrentPdf(null)
  }

  // 打开App Store窗口
  const openAppStoreWindow = () => {
    setOpenWindow('appStore')
    setDefaultMenu('appStore') // 设置默认菜单为App Store
  }

  // 打开Documents窗口
  const openDocumentsWindow = () => {
    setOpenWindow('documents') // 使用同一个MacStyleWindow
    setDefaultMenu('documents') // 设置默认菜单为Documents
  }

  return (
    <div className="desktop-content-container">
      {/* App Store 图标 */}
      <div className="app-store-icon" onClick={openAppStoreWindow} style={{ cursor: 'pointer' }}>
        <FolderIcon imageSrc={appStoreIcon} label="App Store" />
      </div>

      {/* Documents 图标 */}
      <div onClick={openDocumentsWindow} style={{ cursor: 'pointer' }}>
        <FolderIcon imageSrc={folderIcon} label="Documents" />
      </div>

      {/* 条件渲染PDF窗口 */}
      {openWindow === 'pdf' && currentPdf && (
        <PDFWindow type="pdf" onClose={closeWindow}>
          <iframe
            src={currentPdf}
            title="PDF Viewer"
            style={{ width: '100%', height: '100%', border: 'none' }}
            type="application/pdf"
          />
        </PDFWindow>
      )}

      {/* 条件渲染MacStyleWindow */}
      {openWindow === 'appStore' && (
        <MacStyleWindow onClose={closeWindow} defaultMenu={defaultMenu} />
      )}

      {openWindow === 'documents' && (
        <MacStyleWindow onClose={closeWindow} defaultMenu={defaultMenu} />
      )}
    </div>
  )
}

DesktopContent.propTypes = {
  children: PropTypes.node,
}

export default DesktopContent
